import React, { useState } from "react";
import styled from "styled-components";
import { Theme, Button } from "@literati/public-ui-shared-react";
import Modal from "@/atoms/account/Modal";
import {
  refundForIneligibleAddress,
  AddressInformation,
  RefundForIneligibleAddressRes,
} from "lib/api/subscription";
import { isAPIError } from "lib/api/base";

const StyledModal = styled(Modal)`
  .modal-content-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    background: white;
    padding: 3rem 1.5rem;
    max-width: 400px;
  }
`;

const CardTitle = styled.h3`
  text-align: center;
  font-size: 1.25rem;
  line-height: 1.5rem;
  margin: 0 1rem 2rem 1rem;
  font-weight: bold;
`;

const CitySpan = styled.span`
  text-transform: capitalize;
`;

const ErrorMessage = styled.p`
  color: red;
  font-size: 0.875rem;
  line-height: 1.25rem;
  margin-bottom: 1rem;
  text-align: center;
`;

export interface IneligibleAddressModalProps {
  className?: string;
  isOpen: boolean;
  onCancel: () => void;
  onRefund: () => void;
  subscriptionId: number;
  address: AddressInformation;
}

export const IneligibleAddressModal = ({
  className = "",
  isOpen,
  onCancel,
  onRefund,
  subscriptionId,
  address,
}: IneligibleAddressModalProps) => {
  const [refundError, setRefundError] = useState<string>("");

  const handleRefund = async () => {
    const res: RefundForIneligibleAddressRes = await refundForIneligibleAddress(
      { subscriptionId, address }
    );
    if (isAPIError(res)) {
      setRefundError("Something went wrong. Please contact customer support.");
    } else {
      onRefund();
    }
  };

  return (
    <Theme>
      <StyledModal
        className={className}
        isOpen={isOpen}
        onClose={onCancel}
        suppressCloseButton
        suppressLiteratiLogo
      >
        <CardTitle>
          Sorry, looks like we are currently unable to fulfill memberships based
          in your area
          {address ? (
            <CitySpan>{` (${address.city.toLocaleLowerCase()}, ${
              address.state
            })`}</CitySpan>
          ) : (
            ""
          )}
          .
        </CardTitle>

        <Button
          variant="primary"
          className="mb-4"
          onClick={() => handleRefund()}
        >
          Cancel membership & refund
        </Button>
        {refundError && <ErrorMessage>{refundError}</ErrorMessage>}
        <Button variant="secondary" onClick={() => onCancel()}>
          Try a different address
        </Button>
      </StyledModal>
    </Theme>
  );
};

export default IneligibleAddressModal;
